/** Persist only explicitly allowed connector inputs; never provider credentials. */
const FIELDS: Record<string, readonly string[]> = {
  shopify: ['shopDomain'],
  webflow: ['siteId', 'siteLabel'],
  'custom-mcp': ['displayName', 'endpointUrl', 'authMode'],
  analytics: ['ga4', 'clarity', 'bing_webmaster', 'cloudflareAccountId', 'cloudflareZoneId'],
  github: [
    'repositoryId',
    'siteRoot',
    'contentGlobs',
    'editableGlobs',
    'assetGlobs',
    'urlTemplate',
  ],
  wordpress: ['selectedSiteId'],
};
export const CONNECTOR_DRAFT_TTL_MS = 24 * 60 * 60 * 1000;
export function connectorDraftKey(userId: string, projectId: string, moduleId: string): string {
  return `attune:connector:v1:${encodeURIComponent(userId)}:${encodeURIComponent(projectId)}:${moduleId}`;
}
export function sanitizeConnectorDraft(
  moduleId: string,
  value: Record<string, unknown>
): Record<string, string> {
  const output: Record<string, string> = {};
  for (const field of FIELDS[moduleId] || []) {
    const input = value[field];
    if (typeof input !== 'string' || input.length > 4000) continue;
    if (field === 'endpointUrl' && input) {
      try {
        const url = new URL(input);
        if (url.username || url.password || url.search || url.hash) continue;
      } catch {
        continue;
      }
    }
    output[field] = input;
  }
  return output;
}
